import { render, staticRenderFns } from "./WaiterCheckDeleteModal.vue?vue&type=template&id=e1478d90&lang=pug"
import script from "./WaiterCheckDeleteModal.vue?vue&type=script&lang=ts"
export * from "./WaiterCheckDeleteModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports